var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataTransfers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.302809 5.70842C0.0174239 5.42294 -0.0593421 5.0078 0.0725091 4.65257L0.174709 4.45107C0.211309 4.39562 0.254009 4.34302 0.302808 4.2942L0.302815 4.29419L0.304907 4.2921L2.42345 2.17288C2.81385 1.78236 3.44682 1.78236 3.83721 2.17288C4.22761 2.56341 4.22761 3.19657 3.83722 3.5871L3.42183 4.00262L9.06128 4.00262C9.61356 4.00262 10.0613 4.45033 10.0613 5.00262C10.0613 5.5549 9.61356 6.00262 9.06128 6.00262L3.42446 6.00262L3.83722 6.41551C4.22762 6.80604 4.22762 7.4392 3.83722 7.82972C3.44682 8.22025 2.81386 8.22025 2.42346 7.82973L0.306356 5.71195L0.302809 5.70842Z",
    fill: "#212D41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7184 10.2942C16.0038 10.5797 16.0806 10.9948 15.9487 11.35L15.8465 11.5515C15.8099 11.607 15.7672 11.6596 15.7184 11.7084L15.7184 11.7084L15.7163 11.7105L13.5978 13.8297C13.2074 14.2203 12.5744 14.2203 12.184 13.8297C11.7936 13.4392 11.7936 12.8061 12.184 12.4155L12.5994 12L6.95996 12C6.40768 12 5.95996 11.5523 5.95996 11C5.95996 10.4477 6.40768 10 6.95996 10L12.5968 10L12.184 9.58711C11.7936 9.19659 11.7936 8.56342 12.184 8.1729C12.5744 7.78237 13.2074 7.78237 13.5978 8.1729L15.7149 10.2907L15.7184 10.2942Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataTransfers);
export default __webpack_public_path__ + "static/media/data-transfers.694e1b926248f7740eca15d032f469a3.svg";
export { ForwardRef as ReactComponent };